import React, { useEffect, useRef } from "react";
import ContactMeCard from "./ContactMeCard";
import { Row } from "react-bootstrap";

const ContactMe = (props) => {
  const myRef = useRef(null);

  useEffect(() => {
    if (props.sd === "contactme") {
      myRef.current.scrollIntoView();
    }
  }, [props.sd]);

  return (
    <div
      ref={myRef}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1
        style={{
          color: "black",
          fontSize: "50px",
          fontWeight: "bold",
          color: "#155BDD",
          marginTop: "50px",
          fontFamily: "Tenorite",
        }}
      >
        Contact Me
      </h1>
      <br />
      {/* <UnderConst /> */}
      <br />
      <Row
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        <ContactMeCard />
      </Row>
    </div>
  );
};

export default ContactMe;
